export default __webpack_public_path__ + "static/media/1_thumbnail.3d881752.JPG";